'use strict';

import React, { Component } from 'react';
import uniqid from 'uniqid';
import Button from '@material-ui/core/Button';
import Pagination from 'Components/Pagination';
import Slider from 'Components/Slider';
import TextInput from 'Components/Forms/Elements/TextInput';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import handleChange from 'Components/Forms/Functions/handleChange';
import Image from 'Pure/Image';
import Link from 'Pure/Link';
import Logo from 'Pure/Logo';
import truncate from 'Functions/truncate';
import variant from 'Functions/variant';
import bemit from 'Functions/bemit';
import resetStorageBookingValues from 'Functions/resetStorageBookingValues';
import { etablishment as etablishment_icons } from 'Components/IconsConfigs';
import { URL, action } from 'Shared/Routes';
import { coworking_place_types as type_options } from 'Shared/options';
import { etablishment_equipments } from 'Shared/options';
const {
  app,
  qwest,
  moment
} = window;
export default class BackEtablishmentsBlock extends Component {
  state = {
    loading: false,
    data: [],
    data_count: this.props['items-per-page'] || 6,
    page: 0,
    rows_per_page: this.props['items-per-page'] || 6,
    order: this.props['order'] || 'asc',
    order_by: this.props['order-by'] || 'name',
    width: window.innerWidth,
    searched: '',
    type: app.state.session.user?.roles?.includes?.('company_employee') ? 'coworking' : undefined,
    skip: 0,
    limit: 0,
    status_messages: {},
    title: 'Nos différents établissements'
  };
  handleChange = handleChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    resetStorageBookingValues();
    window.localStorage.setItem('widget-date', moment().format('YYYY-MM-DD'));
    component.fetch({});
    app.push({
      event: 'window.resize',
      cb: component.handleResize
    });
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'window.resize',
      cb: component.handleResize
    });
  }
  handleResize = ({
    source
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (window.innerWidth !== state.width) {
      component.setState({
        width: window.innerWidth,
        render_id: uniqid()
      });
    }
  };
  buildSearchResults = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const searched = document.location.pathname.split('/')[3];
    let type = document.location.pathname.split('/')[2] || type_options[0].value;
    if (type === 'tous') {
      type = 'all';
    } else if (type === 'seminaires') {
      type = 'b_seminar';
    }
    component.fetch({
      searched,
      type
    });
  };
  fetch = ({
    searched,
    type,
    page
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    const url = action('getAllEtablishments');
    qwest.post(url, {
      type: 'b_seminar',
      searched: state.searched || '',
      source: props.source
    }).then(function (xhr, response) {
      let title = state.title;
      if (props['search-results'] === true) {
        title = (response.data?.length || 0) + ' Résultat';
        if (response.data?.length > 1) {
          title += 's';
        }
      }
      component.setState({
        loading: false,
        data_count: response.count || 0,
        data: (response.data || []).map(function (data) {
          data.description = truncate(data.description, 160);
          return data;
        }),
        width: window.innerWidth,
        render_id: uniqid(),
        title: title
      });
      if (props.onFetch instanceof Function) {
        props.onFetch({
          data: response.data || []
        });
      }
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handlePageChange = (e, page) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      page: page
    });
    component.fetch({
      page: page
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const modifiers = ['etablishment'].concat(props.bemit || []);
    if (props.slider === true) modifiers.push('slider');
    let etablishments = (state.data || []).map(function (data) {
      let link = '/' + ['etablissements', data.slug].join('/');
      const icons = etablishment_equipments.filter(infos => (data.service || []).includes(infos.value)).map(function (infos) {
        const icons_info = etablishment_icons.find(data => data.value === infos.value);
        if (!icons_info) return null;
        const Icon = icons_info.icon;
        const output = /*#__PURE__*/React.createElement("div", {
          className: "c-media__icon",
          key: infos.value
        }, /*#__PURE__*/React.createElement(Icon, {
          className: "c-media__icon-svg"
        }), /*#__PURE__*/React.createElement("div", {
          className: "u-readers-only"
        }, infos.label || infos.value));
        return output;
      });
      const city = data.address?.city;
      let output = /*#__PURE__*/React.createElement(Button, {
        className: bemit('c-media', modifiers),
        key: data.id,
        onClick: e => props.selectEtablishment(data.id)
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-media__content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-media__img-container"
      }, data.not_configured ? /*#__PURE__*/React.createElement("span", {
        className: "c-media__color-label"
      }, "Ouverture prochaine") : undefined, data.images[0] ? /*#__PURE__*/React.createElement(Image, {
        className: "c-media__img",
        src: variant({
          img: data.images[0],
          size: 600
        }),
        alt: data.title
      }) : /*#__PURE__*/React.createElement(Logo, {
        className: "c-media__img"
      })), /*#__PURE__*/React.createElement("div", {
        className: "c-media__texts"
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-media__title"
      }, data.name, city ? ' - ' + city : undefined), /*#__PURE__*/React.createElement("div", {
        className: "c-media__icons"
      }, icons))));
      if (props.slider === true) {
        output = {
          id: data.id,
          content: output
        };
      }
      return output;
    });
    if (props.slider === true) {
      const width = state.width;
      let slides = [],
        i = 0;
      const per_slide = width >= 1326 ? 3 : width >= 768 ? 2 : 1;
      etablishments.forEach(function (etablishment) {
        let active = slides[i];
        if (!active || active.content.length >= per_slide) {
          if (active && active.content.length >= per_slide) {
            i++;
          }
          slides.push({
            id: etablishment.id,
            content: []
          });
        }
        slides[i].content.push(etablishment.content);
      });
      etablishments = slides.map(function (slide) {
        let i = 0;
        while (slide.content.length < per_slide) {
          const placeholder = /*#__PURE__*/React.createElement("div", {
            className: bemit('c-media', modifiers),
            key: i++
          });
          slide.content.push(placeholder);
        }
        const data = {
          id: slide.id,
          content: /*#__PURE__*/React.createElement("div", {
            className: "o-spaces-block__slide"
          }, slide.content)
        };
        return data;
      });
    }
    let output = /*#__PURE__*/React.createElement("section", {
      className: bemit('o-spaces-block', modifiers)
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__top"
    }, props['with-home-btn'] ? /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__link"
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['blue', 'front']),
      component: Link,
      href: URL('HomePage')
    }, "Retour \xE0 l'accueil")) : undefined, /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--module-booking"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      placeholder: "Recherche (nom)",
      value: state['searched'],
      name: "searched",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Button, {
      onClick: component.fetch,
      className: bemit('c-flat-btn', ['primary'])
    }, "Chercher"))), props.slider !== true ? /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__list"
    }, etablishments, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-media', modifiers)
    }), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-media', modifiers)
    }), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-media', modifiers)
    }), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-media', modifiers)
    }), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-media', modifiers)
    }), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-media', modifiers)
    })) : state.render_id ? /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__slider-container"
    }, /*#__PURE__*/React.createElement(Slider, {
      type: "custom",
      elements: etablishments,
      bemit: ['fill-height', 'show-overflow'],
      "hide-progress": true,
      key: state.render_id
    })) : /*#__PURE__*/React.createElement("div", {
      className: "o-spaces-block__slider-container"
    }), props.pagination !== false ? /*#__PURE__*/React.createElement(Pagination, {
      current: state.page,
      total: state.data_count,
      "items-per-page": state.rows_per_page,
      onChange: component.handlePageChange,
      bemit: ['etablishments-block', 'front']
    }) : undefined);
    return output;
  }
}
